import { Stack, Group, Text, ActionIcon } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import {
  ClipboardCheck,
  ClipboardX,
  Layers,
  ShieldAlert,
  Zap,
  XIcon,
} from 'lucide-react';

import { useEffect, useState } from 'react';

import { TOAST_TYPE, type ToastProps } from './types';
import useToastStyles from './use-toast-styles';
import ToastInfoIcon from '@/assets/icons/icon-info-white.svg';

const Icons = {
  success: <ClipboardCheck />,
  error: <ClipboardX />,
  warning: <ShieldAlert />,
  info: <ToastInfoIcon />,
  primary: <Zap />,
  secondary: <Layers />,
};

export default function Toast({
  title,
  description,
  type = TOAST_TYPE.INFO,
  duration = 5000,
  autoClose = true,
  onClose,
}: ToastProps & { onClose: () => void }) {
  // const [progress, setProgress] = useState(100);
  const [isVisible, setIsVisible] = useState(false);
  const styles = useToastStyles(type);
  const isMobile = useMediaQuery(`(max-width: 767px)`);

  useEffect(() => {
    // Entry animation
    const entryTimer = setTimeout(() => {
      setIsVisible(true);
    }, 10);

    // Progress bar
    // let progressInterval: NodeJS.Timeout;
    // if (duration !== Number.POSITIVE_INFINITY && autoClose) {
    //   console.log('autoClose2', autoClose);

    //   const stepTime = 10;
    //   const step = (stepTime / duration) * 100;

    //   progressInterval = setInterval(() => {
    //     setProgress((prev) => {
    //       if (prev <= 0) {
    //         clearInterval(progressInterval);
    //         handleClose();
    //         return 0;
    //       }
    //       return prev - step;
    //     });
    //   }, stepTime);
    // }

    return () => {
      clearTimeout(entryTimer);
      // if (progressInterval) clearInterval(progressInterval);
    };
  }, [duration, autoClose]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300); // Wait for exit animation
  };
  return (
    <Group
      miw={isMobile ? 340 : 400}
      w="auto"
      gap={4}
      pos="relative"
      bg={styles.background}
      c={styles.text}
      role="alert"
      data-toast-type={type}
      style={{
        padding: 12,
        borderRadius: 4,
        transition: 'all 0.2s ease-in-out',
        transform: isVisible ? 'translateY(0)' : 'translateY(30%)',
        opacity: isVisible ? 1 : 0,
      }}
    >
      {Icons[type]}
      <Stack style={{ marginLeft: 12 }} flex={1}>
        <Text fw={500} size="sm">
          {title}
        </Text>
        {description && <Text size="sm">{description}</Text>}
      </Stack>

      <ActionIcon bg="transparent" onClick={handleClose}>
        <XIcon size={16} style={{ flexShrink: 0, cursor: 'pointer' }} />
      </ActionIcon>
    </Group>
  );
}
